export const CATALOGUE_TEXT = `Quelques exemples visuels de nos travaux...`